// removed by extract-text-webpack-plugin
module.exports = {"key_stats":"key_stats__Gtidt","stat":"stat__2K5LB","value":"value__3JVIt","shrink_unit":"shrink_unit__22HI2","label":"label__1WeFP","extra":"extra__2xlfc","stat_high_temperature":"stat_high_temperature__e12qb","stat_low_temperature":"stat_low_temperature__3HpQ4","stat_high_wind_gust":"stat_high_wind_gust__2qOwv","stat_rainfall":"stat_rainfall__l6zyV"};


//////////////////
// WEBPACK FOOTER
// ./components/key-stats/style.scss
// module id = +/6L
// module chunks = 13